import React from "react"
import * as styles from "./Styles/Row.module.scss"
import "../../../styles/layouts.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import Icon from "../../Utils/Icon"

const FilterRow = (props) => {
  return (
    <div className={styles.row}>
      <a href="#" onClick={props.onClick}>
        <div className="l-flex l-flex-space-between">
          <div className={cn("l-flex", "l-flex-align-center", "left")}>
            <Icon {...props.iconParam} />
            {props.target && (
              <span className={cn("title", "title--selected")}>
                {props.target.name}
              </span>
            )}
            {!props.target && (
              <span className={cn("title", "title--deselected")}>
                {props.fallback}
              </span>
            )}
          </div>
          <div className={styles.right}>
            <Icon type="feather" name="chevron-right" />
          </div>
        </div>
      </a>
    </div>
  )
}
export default FilterRow
